import { RELEASE_DIRECT_MESSAGE_INBOX_FLAG } from 'common/constants';
import { hasUserRoles } from 'user';

const displayLink = (user, __, featureToggles) => {
  const directMessageInboxFlag =
    featureToggles?.[RELEASE_DIRECT_MESSAGE_INBOX_FLAG];

  return (
    hasUserRoles(user, ['admin']) &&
    (directMessageInboxFlag === undefined || directMessageInboxFlag === 'true')
  );
};

export const ENTRY_LINK = {
  path: '/direct-message-inbox',
  text: 'Direct Message Inbox',
  icon: 'mail',
  module: 'direct-message-inbox',
  component: 'Dashboard',
  permission: 'create',
  displayLink: displayLink,
};
